import { uniqBy } from "lodash";
import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

const initialState = {
    ...getInitialState.list()
};

export default function (state = { ...initialState }, action) {
    switch (action.type) {
        case actionTypes.BRANCH_ITEM_ADD: {
            return { ...state, item: getInitialState.branch() };
        }
        case actionTypes.BRANCH_ITEM_CLEAR: {
            return { ...state, item: null };
        }
        case actionTypes.BRANCH_ITEM_SET: {
            const { branch } = action.payload;
            return { ...state, item: branch };
        }
        case actionTypes.BRANCH_ITEM_UPDATE: {
            const { branch } = action.payload;
            const { item } = state;
            return { ...state, item: { ...item, ...branch } };
        }
        case actionTypes.BRANCHES_CLEAR:
        case actionTypes.BRANCHES_GET_REQUEST: {
            return { ...initialState };
        }
        case actionTypes.BRANCHES_GET_SUCCESS: {
            const { branches } = action.payload;
            return helpers.getListReducer(state, branches);
        }
        case actionTypes.BRANCHES_POST_SUCCESS: {
            const { branches } = action.payload;
            return helpers.mergeListReducer(state, [branches]);
        }
        case actionTypes.BRANCH_PATCH_SUCCESS: {
            const { branch } = action.payload;
            return helpers.getListItemReducer(state, branch);
        }
        default: {
            return state;
        }
    }
}
